import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { Heart, Flame, Trophy, TrendingUp, Sparkles } from "lucide-react";
import SectionHead from "@/components/home/SectionHead";

const ICONS = { rally: Flame, friend: TrendingUp, achievement: Trophy, training: Sparkles };

export default function SocialStrip({ highlights }) {
  const navigate = useNavigate();
  const [items, setItems] = useState(highlights || []);
  const react = async (h) => {
    try {
      const { data } = await http.post(`/social/highlights/${h.highlight_id}/react`);
      setItems(items.map((x) => (x.highlight_id === h.highlight_id ? { ...x, reacted: data.reacted, reactions: data.reactions } : x)));
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  return (
    <section data-testid="social-highlights-strip">
      <SectionHead title="From The PaddleVerse" onSee={() => navigate("/social")} />
      <div className="flex gap-3 overflow-x-auto pb-2 px-1 -mx-1 snap-x">
        {items.map((h) => {
          const Icon = ICONS[h.type] || Sparkles;
          return (
            <div key={h.highlight_id} data-testid={`highlight-card-${h.type}`} className="snap-start shrink-0 w-60 rounded-2xl bg-white border border-[#0E395F]/10 overflow-hidden">
              {h.thumbnail && <div className="h-24 bg-cover bg-center" style={{ backgroundImage: `url(${h.thumbnail})` }} />}
              <div className="p-3">
                <span className="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider text-[#F5B700]"><Icon size={12} />{h.type}</span>
                <div className="font-bold text-sm pv-text-dark leading-snug mt-1">{h.title}</div>
                <div className="text-xs text-[#5C7285]">{h.subtitle}</div>
                <button onClick={() => react(h)} className={`mt-2 inline-flex items-center gap-1 text-xs font-bold transition-colors ${h.reacted ? "text-[#F5B700]" : "text-[#5C7285] hover:text-[#0E395F]"}`}>
                  <Heart size={13} fill={h.reacted ? "currentColor" : "none"} />{h.reactions}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
